import { render } from "./school.vue?vue&type=template&id=f155da0c&scoped=true"
import script from "./school.vue?vue&type=script&lang=js"
export * from "./school.vue?vue&type=script&lang=js"

import "./school.vue?vue&type=style&index=0&id=f155da0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f155da0c"]])

export default __exports__